import { wakeBoarder } from '../../../components/shared/vector-images';
import { toggleLayerIfRequired } from '../_helpers';

const layer = {
  displayName: 'Activity areas',
  synonyms: '',
  group: 'mapboxLayer',
  typeUrl: 'activity-area',
  icon: {
    baseShape: wakeBoarder,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 100,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
};

layer.onInitialize = (/* map */) => {
  /* noop */
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'activity-area line', show);
  toggleLayerIfRequired(map, 'activity-area fill', show);
  toggleLayerIfRequired(map, 'activity-area symbol', show);
};

export default layer;
